if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"platform","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return 764 != chunkId},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}